export const environment = {
  state: "development",
  production: false,
  showTesting: true,
  apiUrl: "https://baer-nonprd-app-be-dev.azurewebsites.us/baer/api",
  authUrl: "https://fsappsgateway-stg.fs2c.usda.gov/oauth2",
  clientId: "BAERBARDEV",
  redirectUrl: "https://baer-dev.fs2c.usda.gov/login-redirect"
}
